import React, { useContext } from 'react';
import PrimaryButton from '../buttons/PrimaryButton';
import { AuthContext } from '../context/Auth';
import WindowWrapper from '../context/WindowWrapper';
import InputField from '../forms/InputField';
import Logo from '../../assets/img/logo_other_way_around.png';
import LoadingIcon from '../../assets/img/loading_transp.gif';
import { WindowManagerContext } from '../context/WindowManager';
import ShareButtons from '../misc/ShareButtons';
import { TrackingContext } from '../context/Tracking';

const Login = ({ style, close, className, ...props }) => {
  const { openWindow } = useContext(WindowManagerContext);
  const { auth, login, user } = useContext(AuthContext);
  const { t } = useContext(TrackingContext);

  const [data, setData] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  const editData = (key, value) => {
    setData(old => ({ ...old, [key]: value }));
  };

  const makeLogin = async () => {
    setLoading(true);
    try {
      await login(data.email, data.password);
    } catch (error) {
      setLoading(false);
      alert(error.message);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    t('action', 'opened_login', props.justLoggedOut ? 'from_logout' : '');
  }, []);

  return (
    <>
      <WindowWrapper
        maxWidth={400}
        maxHeight={600}
        className={'window-wrapper nice-scroll ' + (className || '')}
        style={style}
        close={close}
      >
        {
          auth.loggedIn
            ? (
              <center>
                <img src={Logo} width={80} style={{ marginTop: 20 }} />
                <br />
                <h3>Willkommen, {user.name.split(' ')[0]}!</h3>
                <p style={{ fontSize: 14, color: 'grey' }}>Hast du schon eine Bewertung abgegeben?<br />
                  <b>Wenn nein, hilf' deinen Mitstreiter:innen und bewerte eine Klinik aus Famulatur, PJ oder Assistenzarztzeit</b>
                </p>
                <br />
                <PrimaryButton onClick={() => { close(); openWindow('createRating', {}); }}>Jetzt bewerten</PrimaryButton>
                <a style={{ fontSize: 14, color: 'grey', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => close()}>Überspringen</a>
                <br />
                <br />
                <p style={{ fontSize: 14, color: 'grey' }}> Felix Medicus teilen</p>
                <ShareButtons />
              </center>
              )
            : (
              <>
                <center><img src={Logo} width={80} /></center>
                <br />
                <center><h3 style={{ fontWeight: 'bold', fontSize: 24 }}>Einloggen</h3></center>
                {
                  props.justLoggedOut
                    ? (
                      <p style={{ color: 'grey', marginBottom: 0, textAlign: 'center' }}>
                        <i className='fa fa-check' style={{ color: 'green' }} /> Du hast dich erfolgreich ausgeloggt.
                      </p>
                      )
                    : (
                      <p style={{ color: 'grey', marginBottom: 0, textAlign: 'center' }}>
                        Hast du noch keinen Account?<br /><a onClick={() => openWindow('createRating', { reason: 'unlock' })} style={{ textDecoration: 'underline', cursor: 'pointer' }}>Dann gib' jetzt eine Bewertung ab</a><br />und du bist registriert.
                      </p>
                      )
                }
                <br />

                <b>E-Mail-Adresse</b>
                <InputField
                  value={data.email || ''}
                  setValue={value => editData('email', value)}
                  name='email'
                  type='email'
                  label='E-Mail-Adresse'
                  placeholder='E-Mail-Adresse'
                />
                <b>Passwort</b><br />
                <InputField
                  type='password'
                  value={data.password || ''}
                  name='password'
                  setValue={value => editData('password', value)}
                  label='Passwort'
                  placeholder='Passwort'
                  onKeyPress={event => {
                    if (event.key === 'Enter') {
                      makeLogin();
                    }
                  }}
                />
                <br />
                {loading && <center><img src={LoadingIcon} width={18} />&nbsp;&nbsp;Daten werden überprüft...</center>}
                <br />
                <center>
                  <PrimaryButton onClick={() => makeLogin()} scale={1}>Einloggen</PrimaryButton>
                </center>
              </>
              )
        }
      </WindowWrapper>
    </>
  );
};

export default Login;
